import React from "react";
import { Routes, Route } from "react-router-dom";
import {
  PAGE_PORTAL_INVENTORY,
  PAGE_PORTAL_INVENTORY_PRODUCT,
  PAGE_PORTAL_INVENTORY_PRODUCT_DETAIL,
  PAGE_PORTAL_INVENTORY_PRODUCT_ITEM,
  PAGE_PORTAL_INVENTORY_CATEGORIES,
  PAGE_PORTAL_INVENTORY_STOCK
} from "@kivunova/kivufrontendcommon";
import ProductList from "./Products/ProductList";
import ProductDetailPage from "./Products/ProductDetailPage";
import ProductItemDetail from "./Products/ProductItemDetail";
import CategoryList from "./Category/CategoryList";
import StockItemList from "./StockItems/StockItemList";

/**
 * Nested routes for the Inventory module (merged from ProductAndCategoryMFE).
 *
 * The container mounts this at `/portal/inventory/*`, so all paths here are
 * relative — extracted from the common package constants by removing the
 * "inventory/" prefix.
 */
const InventoryRoutes: React.FC = () => {
  // Extract relative paths by removing the "inventory/" prefix
  const inventoryPrefix = `${PAGE_PORTAL_INVENTORY}/`;
  const productPath = PAGE_PORTAL_INVENTORY_PRODUCT.replace(
    inventoryPrefix,
    ""
  );
  const productDetailPath = PAGE_PORTAL_INVENTORY_PRODUCT_DETAIL.replace(
    inventoryPrefix,
    ""
  );
  const productItemPath = PAGE_PORTAL_INVENTORY_PRODUCT_ITEM.replace(
    inventoryPrefix,
    ""
  );
  const categoriesPath = PAGE_PORTAL_INVENTORY_CATEGORIES.replace(
    inventoryPrefix,
    ""
  );
  const stockPath = PAGE_PORTAL_INVENTORY_STOCK.replace(inventoryPrefix, "");

  return (
    <Routes>
      {/* Product Routes */}
      <Route path={productPath} element={<ProductList />} />
      <Route path={productDetailPath} element={<ProductDetailPage />} />
      <Route path={productItemPath} element={<ProductItemDetail />} />

      {/* Category Routes */}
      <Route path={categoriesPath} element={<CategoryList />} />

      {/* Stock items (consumables — E3) */}
      <Route path={stockPath} element={<StockItemList />} />

      {/* Default route - redirect to products */}
      <Route path="/" element={<ProductList />} />
    </Routes>
  );
};

export default InventoryRoutes;
